import React, { memo } from "react";
import { Grid, IconButton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { ReactComponent as ArrowBackIcon } from "@assets/svg/arrow_back.svg";

interface WireInstructionBackButtonProps {
  onClick: () => void;
  label?: string;
}

const useStyles = makeStyles((theme) => ({
  wrapper: {
    paddingBottom: "0 !important",
    marginBottom: theme.spacing(-4),
    [theme.breakpoints.down("lg")]: {
      marginBottom: theme.spacing(-3),
    },
  },
  backButton: {
    display: "inline-flex",
    alignItems: "center",
    color: theme.palette.primary.main,
    padding: theme.spacing(1),
    margin: theme.spacing(-1, -1.5),
    gap: theme.spacing(1.5),
    "&:hover": {
      color: theme.palette.info.main,
    },
  },
  backLabel: {
    fontSize: 16,
    fontWeight: 600,
  },
  backIcon: {
    width: 18,
    height: 18,
  },
}));

export const WireInstructionBackButton = memo(({ onClick, label = "Back" }: WireInstructionBackButtonProps) => {
  const classes = useStyles();

  return (
    <Grid item xs={12} className={classes.wrapper}>
      <IconButton
        className={classes.backButton}
        onClick={onClick}
        data-testid="wire-form-back-button"
        disableRipple
        disableFocusRipple
        disableTouchRipple
      >
        <ArrowBackIcon className={classes.backIcon} />
        <span className={classes.backLabel}>{label}</span>
      </IconButton>
    </Grid>
  );
});

WireInstructionBackButton.displayName = "WireInstructionBackButton";
